import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, admin }) {
    const { user, loading, isAdmin } = useAuth();

    if (loading) {
      return <div className="loading-page"><div className="spinner" /></div>;
    }

    if (!user) {
      return <Navigate to="/login" replace />;
    }

    if (admin && !isAdmin) {
      return <Navigate to="/" replace />;
    }

    return children;
}
